export const useVh = (value: number) => `calc(var(--vh, 1vh) * ${value})`;
